import React from 'react';
import { ReactComponent as Back } from '../../resources/images/back.svg';
import { makeStyles, Box, Typography, SvgIcon, IconButton } from '@material-ui/core';
import { getCustomColors } from '../../styles/CustomColors';
import { monthShortForm } from './CalendarMobile';
import { mapStateToProps, mapDispatchToProps } from './CalendarMobile';
import { connect } from 'react-redux';
import { PATH_CALENDAR } from '../../containers/RoutePaths';
import { useHistory } from 'react-router-dom';
import { getBackSVGViewBox } from '../../styles/BackBarStyle';
import { BloodTestInfo, ImagingTestInfo } from './CalendarDesktop';
import { ICON_NAMES } from './CalendarDesktop';

const Colors = getCustomColors();

const useStyles = makeStyles(theme => ({
    subHeader: {
        color: theme.palette.primary.main,
    },
    header: {
        boxShadow: '0px 1px 4px rgba(186, 186, 186, 0.25)',
        paddingTop: '5px',
        paddingBottom: '5px',
        position: 'fixed',
        zIndex: '9999',
        background: Colors.COLOR_WHITE,
        width: '100%',
    },
    pointerCursor: {
        cursor: 'pointer',
    },
    infoHeader: {
        marginTop: theme.spacing(3),
        fontSize: '30px',
        fontWeight: 600,
    },
    contentBody: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2.5),
        paddingTop: theme.spacing(8.75),
        background: Colors.COLOR_WHITE,
        minHeight: '100vh',
        width: '100%',
    },
    infoBadge: {
        marginTop: theme.spacing(2.5),
    },
    infoSubHeader: {
        fontSize: '16px',
        fontWeight: 600,
        marginTop: '17px',
        marginBottom: '6px',
    },
    infoParagraph: {
        fontSize: '14px',
        fontWeight: 400,
    },
    imagingInfoFirstParagraph: {
        marginTop: theme.spacing(2.125),
    },
}));

function CalendarTestInfoPage({ yearCount, year, monthIndx, configureTestInfoPage, iconName }) {
    const classes = useStyles();
    return (
        <>
            <TestInfoHeader yearCount={yearCount} year={year} monthIndx={monthIndx} configureTestInfoPage={configureTestInfoPage} />
            <Box className={classes.contentBody}>
                {iconName === ICON_NAMES.blood || iconName === ICON_NAMES.bloodAndImaging ? <BloodTestInfo customClasses={classes} /> : null}
                {iconName === ICON_NAMES.imaging || iconName === ICON_NAMES.bloodAndImaging ? <ImagingTestInfo customClasses={classes} /> : null}
            </Box>
        </>
    );
}

const TestInfoHeader = ({ yearCount, year, monthIndx, configureTestInfoPage }) => {
    const classes = useStyles();
    const history = useHistory();

    function onBackClick() {
        configureTestInfoPage('', '', '', '');
        history.push(PATH_CALENDAR);
    }
    return (
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.header}>
            <Box position="absolute" left="24px">
                <IconButton onClick={onBackClick} edge="start">
                    <SvgIcon viewBox={getBackSVGViewBox()} component={Back} />
                </IconButton>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="h4">YEAR[{yearCount}]</Typography>
                <Typography variant="caption" className={classes.subHeader}>
                    [{`${monthShortForm[monthIndx]} ${year}`}]
                </Typography>
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarTestInfoPage);
